module.exports = __webpack_public_path__ + "14777e715d937cb2751ef0a860d48251.svg";